import { request } from "@/api/client";

export type BillingSummary = {
  seat_count: number;
  seat_limit?: number | null;
  tier?: string | null;
  subscription_status?: string | null;
  current_period_end?: string | null;
  stripe_customer_id?: string | null;
  billing_exempt?: boolean;
  plan_name?: string | null;
  price_amount?: number | null;
  price_currency?: string | null;
  price_interval?: string | null;
  price_interval_count?: number | null;
  next_invoice_date?: string | null;
  payment_method_brand?: string | null;
  payment_method_last4?: string | null;
  payment_method_exp_month?: number | null;
  payment_method_exp_year?: number | null;
  can_manage?: boolean;
};

export type BillingCheckoutResponse = {
  checkout_url: string;
};

export type BillingPortalResponse = {
  portal_url: string;
};

export function fetchBillingSummary() {
  return request<BillingSummary>("/billing/summary");
}

export function createBillingCheckout(payload: {
  tier?: string;
  seats_total?: number;
  promo_code?: string;
  success_url?: string;
  cancel_url?: string;
}) {
  return request<BillingCheckoutResponse>("/billing/checkout", {
    method: "POST",
    body: payload,
  });
}

export function createBillingPortal() {
  return request<BillingPortalResponse>("/billing/portal", {
    method: "POST",
  });
}

export type BillingSupportPayload = {
  request_type: "help" | "pause" | "cancel";
  message: string;
  subject?: string;
};

export function sendBillingSupportRequest(payload: BillingSupportPayload) {
  return request<{ status: string }>("/billing/support", {
    method: "POST",
    body: payload,
  });
}

export function syncBillingSeatLimit(payload: { org_id?: string }) {
  return request<{ org_id: string; seat_limit?: number | null; status?: string | null }>("/billing/sync", {
    method: "POST",
    body: payload,
  });
}

export function updateBillingSeatLimit(payload: { org_id?: string; seat_limit: number }) {
  return request<{ org_id: string; seat_limit: number }>("/billing/seat-limit", {
    method: "POST",
    body: payload,
  });
}
